/**
 * @file persistenceIdentity.js
 * Utility per associare le preferenze all'utente autenticato, indipendentemente dai ruoli.
 */

/**
 * Costruisce l'identità dal contesto di autenticazione, non dai dati nello storage.
 * Normalizza l'email; il cambio di ruolo non modifica l'identità delle preferenze.
 *
 * @param {object} app - Contesto applicativo con stato auth ed email
 * @returns {{email: string}|null} Identità oppure null se non disponibile
 */
export function getPersistenceIdentity(app) {
  if (!app.isAuthReady || !app.isAuthenticated || !app.userEmail) return null;
  const email = app.userEmail.trim().toLowerCase();
  if (!email) return null;
  return { email };
}

/**
 * Produce una firma deterministica dell'identità normalizzata per chiavi e confronti.
 * È una rappresentazione JSON, non un token di autenticazione né una firma crittografica.
 *
 * @param {{email: string}|null} identity - Identità normalizzata
 * @returns {string|null} Firma dell'identità oppure null
 */
export function identitySignature(identity) {
  return identity ? JSON.stringify([identity.email]) : null;
}
